import { createSvgIcon } from '@mui/material';

export const SecureIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22c-2.31667-.5833-4.22917-1.9125-5.7375-3.9875C4.75417 15.9375 4 13.6333 4 11.1V5l8-3 8 3v6.1c0 2.5333-.7542 4.8375-2.2625 6.9125C16.2292 20.0875 14.3167 21.4167 12 22Zm0-2.1c1.7333-.55 3.1667-1.65 4.3-3.3 1.1333-1.65 1.7-3.4833 1.7-5.5V6.375l-6-2.25-6 2.25V11.1c0 2.0167.56667 3.85 1.7 5.5s2.5667 2.75 4.3 3.3Z"
      fill="currentColor"
    />
  </svg>,
  'SecureIcon',
);
